module.exports = __webpack_public_path__ + "img/red-arrow-down.8945400f.svg";